import * as Yup from "yup";

const godownSchema = {};

godownSchema.validateGodownAdd = () => {
  return Yup.object({
    godown_name: Yup.string()
      .trim()
      .required("Godown name is required.")
      .min(3, "Godown name minimum length is 3")
      .max(45, "Godown name should be at most 45 characters.")
      .matches(/^[aA-z0-9Z-\s]+$/, `Godown name should be Alphanumeric only`),
    tally_godown_name: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test(
        "tally_godown_name_validation",
        "Godown name must be 3-45 characters and alphanumeric",
        function (value) {
          if (!value) return true;

          return (
            value.length >= 3 &&
            value.length <= 45 &&
            /^[aA-z0-9Z-\s]+$/.test(value)
          );
        },
      ),
    godown_address: Yup.string(),
    branch_id: Yup.array()
      .min(1, "At least one branch is required.")
      .of(Yup.number().required("Branch is required.")),
  });
};

godownSchema.validateGodownEdit = () => {
  return Yup.object({
    godown_name: Yup.string()
      .trim()
      .required("Godown name is required.")
      .min(3, "Godown name minimum length is 3")
      .max(45, "Godown name should be at most 45 characters.")
      .matches(/^[aA-z0-9Z-\s]+$/, `Godown name should be Alphanumeric only`),
    tally_godown_name: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test(
        "tally_godown_name_validation",
        "Godown name must be 3-45 characters and alphanumeric",
        function (value) {
          if (!value) return true;

          return (
            value.length >= 3 &&
            value.length <= 45 &&
            /^[aA-z0-9Z-\s]+$/.test(value)
          );
        },
      ),
    godown_address: Yup.string(),
    branch_id: Yup.array()
      .min(1, "At least one branch is required.")
      .of(Yup.number().required("Branch is required.")),
  });
};

export default godownSchema;
